import { createReducer, on } from '@ngrx/store';
import { proceduresListingInitialState, ProceduresListingState } from '@store/states/procedures-listing.state';
import { proceduresListingActions } from '@store/actions/procedures-listing.actions';
import { clone } from 'lodash-es';

export const proceduresListingReducer = createReducer(
  proceduresListingInitialState,
  on(
    proceduresListingActions.setFilters,
    (state, { filters }): ProceduresListingState => ({
      ...state,
      filters,
      pagination: {
        ...state.pagination,
        pageIndex: 1,
      },
    })
  ),
  on(
    proceduresListingActions.setData,
    (state, { data }): ProceduresListingState => ({
      ...state,
      data: clone(data),
      error: null,
    })
  ),
  on(
    proceduresListingActions.setError,
    (state, { error }): ProceduresListingState => ({
      ...state,
      error,
      data: null,
    })
  ),
  on(
    proceduresListingActions.setPagination,
    (state, { pagination }): ProceduresListingState => ({
      ...state,
      pagination: { ...pagination },
    })
  ),
  on(
    proceduresListingActions.setType,
    (state, { procedureType }): ProceduresListingState => ({
      ...state,
      type: procedureType,
      pagination: {
        ...state.pagination,
        pageIndex: 1,
      },
    })
  )
);
